import { createApp } from 'vue'
import App from './App.vue'
import Axios from "axios"
import Router from './router'
import Store from './store'
import VueSweetalert2 from 'vue-sweetalert2';
import MaterialDashboard from "./material-dashboard";
import i18n from './i18n'; //Used for translation
import 'sweetalert2/dist/sweetalert2.min.css'; //User for message
import { showError, showSuccess } from './helpers/alerts';

Axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;

// Check for daily expiration
const storedDate = localStorage.getItem('login-date');
const today = new Date().toDateString();

if (storedDate && storedDate !== today) {
  sessionStorage.clear();
  localStorage.removeItem('login-date');
  window.location.href = '/login';
}

// Fetch from sessionStorage instead of localStorage
const token = sessionStorage.getItem('sheepbase-token');
const user = sessionStorage.getItem('user');
const keeperLocationId = sessionStorage.getItem('keeperLocationId');
const keeperUBN = sessionStorage.getItem('keeperUBN');
const keeperAssociationId = sessionStorage.getItem('keeperAssociationId');
const keeperRVORelationNumber = sessionStorage.getItem('keeperRVORelationNumber');
const keeperRVOConnected = sessionStorage.getItem('keeperRVOConnected');
const associationAdminAssociationId = sessionStorage.getItem('associationAdminAssociationId');
const associationAdminAssociationName = sessionStorage.getItem('associationAdminAssociationName');
const associationWebsiteURL = sessionStorage.getItem('associationWebsiteURL');
const roleName = sessionStorage.getItem('roleName');

if (token) {
    Axios.defaults.headers.common['Authorization'] = 'bearer ' + token;
    Store.commit('user', JSON.parse(user));
    Store.commit('setShowNavbar', true);
    Store.commit('setKeeperLocationId', keeperLocationId);
    Store.commit('setKeeperUBN', keeperUBN);
    Store.commit('setKeeperAssociationId', keeperAssociationId);
    Store.commit('setKeeperAssociationId', keeperAssociationId);
    Store.commit('setKeeperRVORelationNumber', keeperRVORelationNumber);
    Store.commit('setKeeperRVOConnected', keeperRVOConnected);
    Store.commit('setAssociationAdminAssociationId', associationAdminAssociationId);
    Store.commit('setAssociationAdminAssociationName', associationAdminAssociationName);
    Store.commit('setAssociationWebsiteURL', associationWebsiteURL);
    Store.commit('setRoleName', roleName);
}

const app = createApp(App);

// Attach globally so you can use this.$showMessage in any component
app.config.globalProperties.$showError = function (message, options = {}) {
  showError(message, this.$t, options);
};

app.config.globalProperties.$showSuccess = function (message, options = {}) {
  showSuccess(message, this.$t, options);
};

app.use(Router).use(Store).use(VueSweetalert2).use(MaterialDashboard).use(i18n).mount('#app')

//import 'jquery/src/jquery.js';
//import 'popper.js/dist/popper.min.js';
//import 'bootstrap/dist/js/bootstrap.min.js';